import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login'
import Workorders from '../components/Workorders'
import CreateWorkorders from '../components/CreateWorkorder'
import ViewWorkorder from '../components/ViewWorkorder'
import firebase from 'firebase'
import store from '../store'

Vue.use(Router)

function guard(to, from, next){
    console.log(store);
    if(store.state.user.loggedIn) {
        // or however you store your logged in state
        next(); // allow to enter route
    } else{
        next('/create-workorder'); // go to '/login';
    }
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
        path: '/',
        name: 'Workorders',
        beforeEnter: guard,
        component: Workorders
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/workorder/:id',
        name: 'ViewWorkorder',
        component: ViewWorkorder
    },
    {
        path: '/create-workorder',
        name: 'CreateWorkorder',
        component: CreateWorkorders
    },
]
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
        next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})

export default router
